<template>
<div class="site-content">
  <div class="site-content-banner">
    <div class="site-content-page">
      <div class="content-row">
          <div class="info-detail-title-1">
            <div class="title-img">
                <img :src="detail.cover_img" height="60px"/>
            </div>
            <div class="title-info">
              <div class="title">{{detail.title}}</div>
              <table class="title-detail-table">
                <tr>
                  <td>展会时间</td><td class="td-value">{{detail.start_time}}</td>
                </tr>
                <tr>
                  <td>展会地址</td><td class="td-value">{{detail.place}}</td>
                </tr>
                <tr>
                  <td>报名时间</td><td class="td-value">{{detail.start_time}}</td>
                </tr>
              </table>
            </div>
            <div class="title-act">
              <a href="#" class="collection">收藏</a>
              <a href="#" class="share">分享</a>
            </div>
          </div>
      </div>
    </div>
  </div>
  <div class="site-content-page">
    <div class="content-row">
      <div class="content-col col-per-70">
        <div class="info-list-title">
          <span>展会详情</span>
        </div>
        <div class="info-detail-content">
          <p v-html="detail.content"></p>
        </div>
      </div>
      <div class="content-col col-per-30">
        <div class="info-list-title">
          <span>主办方信息</span>
        </div>
        <div class="info-detail-content">
          <ul class="info-detail-zh-other">
            <li class="label">主办方</li>
            <li class="value">{{detail.owner}}</li>
            <li class="label">协办单位</li>
            <li class="value">{{detail.host}}</li>
          </ul>
        </div>
        <div class="info-list-title">
          <span>联系信息</span>
        </div>
        <div class="info-detail-content">
          <ul class="info-detail-zh-other">
            <li class="label">联系人</li>
            <li class="value">{{detail.contact}}</li>
            <li class="label">联系电话</li>
            <li class="value">{{detail.phone}}</li>
            <li class="label">联系地址</li>
            <li class="value">{{detail.address}}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import InfoPageList01 from '../block/InfoPageList01'
import InfoList04 from '../block/InfoList04'
import InfoDetail01 from '../block/InfoDetail01'
export default {
  name: 'Detail02',
  components: {
    'infoDetail-01': InfoDetail01,
    'infoList-04': InfoList04,
  },
  data() {
    return {
      msg: '',
      detail:{},
    }
  },
  methods:{
    detail_Req(detailId){
      let that=this;
      let params={id:detailId};
      that.$dataApi.expoDetail(params).then(res =>{
          that.msg=res.msg;
          that.detail=res.data;
          //console.log('结束请求Vue-axios：'+JSON.stringify(that.detailInfo))
        });
    },
  },
  created:function(){
    let that=this;
    let detailId=that.$route.params.id;
    //this.newsDetail=this.Global.newsDetail;
    //console.log("当前导航页："+this.Global.siteDefaultNav);

    that.detail_Req(detailId);
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.col-per-70 {
  flex-grow:3;
}

.col-per-30 {
  flex-grow:1;
}

.info-detail-title-1{
  position:relative;
  width:100%;
  height:180px;
  background:#eee;
  padding:20px 20px 20px 0px;
  margin-top:-20px;
  margin-bottom:0px;
  border-bottom:0px;
  text-align:left;
}
.info-detail-title-1 .title-img{
  float:left;
  width: 240px;
  height:140px;
  text-align:left;
  background:#ddd;
}

.info-detail-title-1 .title-img img{
  float:left;
  width: 240px;
  height:140px;
}

.info-detail-title-1 .title-info{
  float:left;
  width: calc(100% - 440px);
  text-align:left;
}

.info-detail-title-1 .title-act{
  float:left;
  width:200px;
  height:80px;
  text-align:center;
  line-height:80px;
}

.info-detail-title-1 .title{
  padding:5px 5px 5px 20px;
  height:70px;
  font-size:16px;
  font-weight:800;
  line-height:30px;
  text-align:left;
}

.title-detail-table{
  padding-left:20px;
  font-size:12px;
  line-height:20px;
  color:#555555;
}

.title-detail-table .td-value{
  padding-left:20px;
  color: var(--color6);
}

.info-detail-title-1 .collection{
  text-decoration: none;
  padding-right:10px;
  padding-left:20px;
  font-size:12px;
  font-weight:400;
  line-height:40px;
  text-align:left;
  color:#9FA2A6;
  background-image:url(./../../assets/collection.png);
  background-size: 18px 18px;
  background-repeat: no-repeat;
  background-position: 0px 0px;
}

.info-detail-title-1 .share{
  text-decoration: none;
  padding-right:10px;
  padding-left:20px;
  font-size:12px;
  font-weight:400;
  line-height:40px;
  text-align:left;
  color:#9FA2A6;
  background-image:url(./../../assets/share.png);
  background-size: 15px 15px;
  background-repeat: no-repeat;
  background-position: 0px 0px;
}

.info-detail-zh-other{
  list-style-type: none;
  padding: 20px;
  font-size:12px;
  background:#eee;
}

.info-detail-zh-other li {
  margin: 0px 0px 2px 0px;
  padding:4px;
  height:20px;
  text-align:left;
}

.info-detail-zh-other .label {
  margin: 0px 0px 2px 0px;
  padding:4px;
  height:20px;
  text-align:left;
  color:#888;
}

.info-detail-zh-other .value {
  position:relative;
  margin: 0px 0px 2px 0px;
  padding:4px;
  height:100%;
  text-align:left;
  color:#000;
}

</style>



// WEBPACK FOOTER //
// src/components/page/Detail02.vue